//const Backofficebff         : string = "/backofficebff/service/api/v1";
//const BackofficebffV2         : string = "/backofficebff/service/api/v2";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
export const LocalizationManagementQuery: any = {
    GetCultureList: Backofficebff + '/v1/localizationmanager/culturelist',
    GetApplicationList: Backofficebff + '/v1/localizationmanager/applicationlist',
};
